import * as types from '../utils/mutation-types.js'

const state = {
  menu: ''
}

const mutations = {
  [types.MENU] (state, { num }) {
    state.menu = num
  }
}

const getters = {
  getMenu: state => state.menu
}

const actions = {
  [types.MENU] ({ commit }, num) {
    commit(types.MENU, { num })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/transition.js